export default __webpack_public_path__ + "static/media/thumbnail.1a9782a1.png";